import Vue from 'vue';

const EventBus = new Vue();

const events = [
  'ShowModal',
  'CloseModal',
  'UpdatePageTitle',
  'UserImageGroupMoreUserClicked',
  'UpdateBackToBtn',
  'UpdateHeaderBtnText',
  'AssignmentCreated',
  'AssignmentUpdated',
  'HeaderButtonClicked',
  'HeaderMoveStudentClicked',
  'HeaderRemoveStudentClicked',
  // 'ShowSuggester',
  'ShowGlobalToast',
  'CloseGlobalToast',
  'HideBoxShadow',
  'UsersFirstClassCreated',
  'AccordionAssignedButtonClicked',
  'SetClassStatisticsQuery',
  'SetStudentStatisticsQuery',
  'UpdatePageSubTitle',
  'HeaderSearchTriggered',
  'FavoriteBtnClicked',
  'OpenMultipleModalWithState',
  'ReOpenNewAssignmentModal',
  'LoadNewAssignmentModalState',
  'SessionExpired',
  'NotificationTriggered',
  'SyncronizationFinished',
  'SessionLeft',
  'CookieBotTriggered',
  'ClearTeacherStatisticsInterval',
  'SiteLanguageChanged'
];

events.forEach((eventName) => {
  EventBus[`on${eventName}`] = (component, callback) => {
    EventBus.$on(eventName, callback);
  };
  EventBus[`off${eventName}`] = (component, callback) => {
    EventBus.$off(eventName, callback);
  };
  EventBus[eventName.charAt(0).toLowerCase() + eventName.slice(1)] = (payload) => {
    EventBus.$emit(eventName, payload);
  };
});

export default EventBus;



// WEBPACK FOOTER //
// ./src/components/shared/eventbus.js